
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import EliotTreeNode from '~/components/Eliot/EliotTreeNode.vue';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { filterOnSearchText } from '~/helpers';
import { NodeEliot } from '~/interfaces/eliot.interface';
import { treeNodeKey } from '~/interfaces/helper.interface';
import UserRightsMixin from '~/mixins/UserRightsMixin';
import { Plant } from '~/models/plant.model';
import { EliotModule } from '~/store/modules/eliot';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';

@Component({
    components: {
        NetatmoIcon,
        EliotTreeNode,
    },
})
export default class EliotTreeMenu extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {

    @Prop() readonly search!: string;

    openedPlantNodes: string[] = [];
    plantNodes: NodeEliot[] = [];

    get plants() {
        return EliotModule.plants;
    }
    get filter() {
        return (item: NodeEliot, search: string) =>
            filterOnSearchText(item, search, ['name', 'macAddress', 'id'] as treeNodeKey[]);
    }

    @Watch('plants', { immediate: true, deep: true })
    updateTreeNodes() {
        const plantNodes: NodeEliot[] = [];
        this.plantNodes = this.createPlantNodes(plantNodes);
        EliotModule.plants.forEach((plant) => {
            if (plant.areGatewaysShown) {
                this.createGatewayNodes(plant.id);
            }
        });
    }

    getGateways(plantId: string) {
        return EliotModule.gatewaysOfPlant(plantId);
    }

    createGatewayNodes(plantId: string) {
        const plantNodesCopy: NodeEliot[] = JSON.parse(JSON.stringify(this.plantNodes));
        // create gateway nodes and push them as children of their plant node
        this.getGateways(plantId).forEach((gateway) => {
            const gatewayNode: NodeEliot = {
                id: gateway.macAddress || gateway.id,
                name: gateway.name,
                type: 'gateway',
                icon: 'home',
                plantId: gateway.plantId,
                children: [],
                hasToggle: false,
            };
            // add the gateways to the correponding parent node.
            const parentNode = plantNodesCopy.find((node) => node.id === plantId);
            if (parentNode) {
                parentNode.children.push(gatewayNode);
            }
            // Open by default
            this.openedPlantNodes.push(plantId);
        });

        this.plantNodes = plantNodesCopy;
    }

    createPlantNodes(plantNodes: NodeEliot[]) {
        const plantNodesCopy: NodeEliot[] = JSON.parse(JSON.stringify(plantNodes));
        this.plants.forEach((plant: Plant) => {
            plantNodesCopy.push({
                id: plant.id,
                name: plant.name,
                type: 'plant',
                icon: 'home',
                children: [],
                hasToggle: true,
            });
        });

        return plantNodesCopy;
    }

    isActive(id: string, type: string) {
        if (type === 'plant') {
            return EliotModule.currentPlantId === id;
        } else if (type === 'gateway') {
            return EliotModule.currentGatewayId === id;
        }
    }

    removeGatewayNodes(plantId: string) {
        const plantNodesCopy: NodeEliot[] = JSON.parse(JSON.stringify(this.plantNodes));

        const parentNode = plantNodesCopy.find((node) => node.id === plantId);
        if (parentNode) {
            parentNode.children = [];
        }
        this.plantNodes = plantNodesCopy;
    }
}
